import React from "react";

export interface InsightHighlightCardProps {
  accentColor: "success" | "warning" | "brand" | "neutral";
  title: string;
  description: string;
  /** Merged onto the root; use e.g. `h-full min-h-0` for equal-height columns */
  className?: string;
}

/** Alert/warning cards (bad, needs attention) use red; success/neutral/brand unchanged */
const accentBarClass: Record<InsightHighlightCardProps["accentColor"], string> = {
  success: "bg-success-500",
  warning: "bg-error-500",
  brand: "bg-brand-500",
  neutral: "bg-neutral-400",
};

export function InsightHighlightCard({
  accentColor,
  title,
  description,
  className = "",
}: InsightHighlightCardProps) {
  return (
    <div
      className={[
        "flex h-full w-full min-h-0 gap-3 rounded-2xl bg-white px-5 py-4 shadow-sm items-stretch",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <div className={`flex w-1 flex-none flex-col self-stretch rounded-full ${accentBarClass[accentColor]}`} />
      <div className="flex min-h-0 flex-1 flex-col items-start justify-center gap-1">
        <span className="text-body-bold font-body-bold text-neutral-900">{title}</span>
        <span className="text-body font-body text-neutral-500">{description}</span>
      </div>
    </div>
  );
}
